// extracted by mini-css-extract-plugin
module.exports = {"more":"MoreIcon_more__1BMEB","large":"MoreIcon_large__9B3xd"};